import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    ChartImageSectionWrapper,
    DataSection,
    DataSectionWrapper,
} from "./images-part/StyledAIReportCtaSectionImages";

export const AIReportCtaSectionText = styled(Flex)`
    flex-direction: column;
    gap: 16px;
`;

export const StyledAIReportCtaSection = styled(Flex)`
    width: 100%;
    height: 162px;
    background-color: ${colorsPalettes.midnight[600]};
    gap: 12px;
    justify-content: space-between;
    border-radius: 8px;
    padding: 28px 67px 32px 36px;
    margin-bottom: 24px;
    overflow: hidden;
    position: relative;

    @container ai-report-cta-section-wrapper (1046px <= width < 1364px) {
        height: 166px;

        ${ChartImageSectionWrapper} {
            right: -120px;
            bottom: -13px;
        }

        ${DataSectionWrapper} {
            right: 270px;
            bottom: 2px;
        }
    }

    @container ai-report-cta-section-wrapper (888px <= width < 1046px) {
        height: 138px;
        padding: 18px 36px;

        ${ChartImageSectionWrapper} {
            right: 15px;
            top: 55px;
        }

        ${DataSectionWrapper} {
            bottom: 10px;
        }

        ${DataSection} {
            padding: 7px 7px 14px;
        }
    }

    @container ai-report-cta-section-wrapper (764px <= width < 888px) {
        height: 182px;
        padding: 18px 24px;

        ${AIReportCtaSectionText} {
            width: 344px;
        }

        ${ChartImageSectionWrapper} {
            right: -70px;
            bottom: -12px;
        }

        ${DataSectionWrapper} {
            right: 277px;
        }

        ${DataSection} {
            padding: 7px 7px 14px;
        }
    }

    @container ai-report-cta-section-wrapper (width <= 764px) {
        height: 182px;
        padding: 18px 24px;

        ${AIReportCtaSectionText} {
            width: 344px;
        }

        ${ChartImageSectionWrapper} {
            right: -180px;
            bottom: -12px;
        }

        ${DataSectionWrapper} {
            right: 177px;
        }

        ${DataSection} {
            padding: 7px 7px 14px;
        }
    }
`;

export const CloseButton = styled(Button)`
    position: absolute;
    min-width: 0px;
    width: 16px !important;
    height: 16px !important;
    border-radius: 16px;
    padding: 12px;
    top: 4px;
    right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
